import { StandardProps } from "@/types/types";
import * as components from "./index";
import React from "react";

type StandardComponent = (
  props: StandardProps & { sizes: string },
) => React.ReactNode;

type ComponentMap = { [name: string]: StandardComponent };

export const componentMap: ComponentMap = components;
